import { render } from "./allproductlocation.vue?vue&type=template&id=4062b64c&scoped=true"
import script from "./allproductlocation.vue?vue&type=script&lang=js"
export * from "./allproductlocation.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./allproductlocation.vue?vue&type=style&index=1&id=4062b64c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4062b64c"]])

export default __exports__